module.exports = __webpack_public_path__ + "static/img/ri-shopping-cart-line.117b06a6.svg";